import { useQuery } from '@tanstack/react-query';
import tourBudgetApi from '@/features/dashboard/tourBudget/api/tourBudgetApi.ts';
import { tourBudgetApiQueryKeys } from '@/features/dashboard/tourBudget/api/tourBudgetApi.queryKeys.ts';

const useGetTourBudget = (tourId: string) => {
  return useQuery({
    queryKey: tourBudgetApiQueryKeys.byTourId(tourId),
    queryFn: () => tourBudgetApi.getBudget(tourId),
    enabled: !!tourId,
  });
};

export default useGetTourBudget;
